import PosterCard from './PosterCard.jsx';

export default function Shelf({ title, subtitle, movies, loading, onPosterClick }) {
  return (
    <section className="hb-shelf">
      <div className="hb-shelf__sign">
        <h2 className="hb-shelf__title">{title}</h2>
        {subtitle ? <p className="hb-shelf__subtitle">{subtitle}</p> : null}
      </div>
      <div className="hb-shelf__rail">
        {loading ? (
          Array.from({ length: 8 }).map((_, i) => <div key={i} className="hb-poster hb-poster--skeleton" />)
        ) : movies.length === 0 ? (
          <div className="hb-shelf__empty">Nothing here for the current filters.</div>
        ) : (
          movies.map((m) => (
            <PosterCard key={m.id} movie={m} onClick={() => onPosterClick?.(m)} />
          ))
        )}
      </div>
    </section>
  );
}
